import styles from './styles.module.scss';
import clsx from 'clsx';
import { Loading } from 'components/loading';
import { InlineSvg } from 'components/svg';
import { NotificationMessage } from 'features/notifications/api/models';
import { useReadNotificationMutation } from 'features/notifications/api/repositories/use-read-notification.mutation';
import { useIsInIframe } from 'features/notifications/hooks/use-is-in-Iframe';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';

export const MessageItem: FC<{ item: NotificationMessage }> = ({ item }) => {
  const isInIframe = useIsInIframe();
  const [msgItem, setMsgItem] = useState<NotificationMessage>();
  const { mutate: mutateRead, isLoading: isLoadingRead } = useReadNotificationMutation();

  useEffect(() => {
    setMsgItem(item);
  }, [item]);

  if (!msgItem) return null;

  const isAutomatic = !msgItem.sender;

  const handleClickRead = () => {
    if (msgItem.isRead || !msgItem.id) return;

    mutateRead(
      { id: msgItem.id! },
      {
        onSuccess: () => {
          setMsgItem({ ...msgItem, isRead: true });
        }
      }
    );
  };

  return (
    <div
      className={clsx(styles.container, !msgItem.isRead ? styles.newContainer : null, isInIframe ? styles.frame : null)}
    >
      {!msgItem.isRead && (
        <div className={clsx(styles.newContainer)}>
          <div className={clsx(styles.circle)}></div>
        </div>
      )}
      <div className={clsx(styles.msgContainer)}>
        <div className="d-flex flex-nowrap w-100 justify-content-between">
          <div className={clsx(styles.header)}>
            {isAutomatic ? 'Automatic notification' : msgItem.sender?.name ?? '-'}
          </div>
          {msgItem.createdAt && <div className={clsx(styles.time)}>{moment(msgItem.createdAt).format('HH:mm')}</div>}
        </div>
        <div className="my-3" dangerouslySetInnerHTML={{ __html: msgItem.body ?? '' }} />
        <div className={clsx(styles.wipInfo)}>
          <div className="d-flex flex-nowrap gap-4">
            <div>
              <InlineSvg path="/media/icons/custom/cd.svg" className={clsx(styles.cd)} />
            </div>
            <div>
              {msgItem.sourceType} - {msgItem.sourceId}
            </div>
            <div>
              {msgItem.sourceUrl && (
                <a href={msgItem.sourceUrl} target="_blank" rel="noreferrer">
                  View <InlineSvg path="/media/icons/custom/black-right.svg" className={clsx(styles.blackRight)} />
                </a>
              )}
            </div>
          </div>
          <button type="button" className={clsx(styles.status)} onClick={handleClickRead} disabled={isLoadingRead}>
            {!msgItem.isRead ? (
              <InlineSvg path="/media/icons/custom/check-circle.svg" />
            ) : (
              <InlineSvg path="/media/icons/custom/duble-check-circle.svg" />
            )}
          </button>
        </div>
      </div>
      {isLoadingRead && (
        <div className={styles.preloadContainer}>
          <div className={styles.overlay}></div>
          <Loading />
        </div>
      )}
    </div>
  );
};
